import { render } from "./Environment.vue?vue&type=template&id=5895a3bc"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__